import { render, staticRenderFns } from "./editionpay.vue?vue&type=template&id=0b1e54a8&scoped=true&"
import script from "./editionpay.vue?vue&type=script&lang=js&"
export * from "./editionpay.vue?vue&type=script&lang=js&"
import style0 from "./editionpay.vue?vue&type=style&index=0&id=0b1e54a8&scoped=true&lang=scss&"
import style1 from "./editionpay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e54a8",
  null
  
)

export default component.exports